import update from 'immutability-helper';

export const updateObject = (oldObject: object, updatedProperties: object) => {
  const updatedObject = update(oldObject, { $merge: updatedProperties });
  return updatedObject;
};

export default updateObject;
